module.exports = __webpack_public_path__ + "img/bg_function04_1_d.106cda57.gif";